module.exports = __webpack_public_path__ + "static/img/mainbusiness05.85bb004.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/01/mainbusiness05.png
// module id = Xlor
// module chunks = 1